import { IconButton, Tooltip, Typography } from "@mui/material"
import SettingsIcon from '@mui/icons-material/Settings';
import { useLocation, useNavigate } from "react-router-dom";
import { FieldValues, UseFormReturn } from "react-hook-form";
import { DocumentAdd, DocumentEdit } from "../../../../models/document";
import { DocumentSettings } from "../../../../models/document-settings";
import { DocumentStructure } from "../../../../models/document-structure";
import MuiInput from "@shared/ui/mui-input/MuiInput";
import { FieldsRow } from '@shared/ui/layout/FieldsRow';
import { ItemsFormType, PaymentsFormType, WorksFormType } from "../../pages/add-document/AddDocument.types";


// theme
import { useTheme } from "@emotion/react";


interface DocumentCustomDataProps {

    documentForm: UseFormReturn<DocumentAdd> | UseFormReturn<DocumentEdit>;
    worksForm: UseFormReturn<WorksFormType>
    itemsForm: UseFormReturn<ItemsFormType>
    paymentsForm: UseFormReturn<PaymentsFormType>

    settings: DocumentSettings;
    structure: DocumentStructure[];

    isDocumentClosed?: boolean;
}


function DocumentCustomData({ isDocumentClosed, documentForm, worksForm, itemsForm, paymentsForm, settings, structure }: DocumentCustomDataProps) {

    const navigate = useNavigate();
    const { state } = useLocation(); // state data from another page
    const theme = useTheme();

    function renderCustomDataField<T extends FieldValues>(field: DocumentStructure, documentForm: UseFormReturn<T>) {

        const isCustomDataField = field.type === "מסמך" && !!field.custom_field && field.show_form;

        if (isCustomDataField) {
            return <MuiInput
                key={field.field_name}
                field={field}
                variant='outlined'
                useForm={documentForm}
                showRequired
                disabled={isDocumentClosed}
            />
        }
    }


    function createState(){
        return {
            ...state,
            document_settings_id: settings?.id,

            document_account: documentForm.getValues().document_account,
            car: documentForm.getValues().car,

            works: worksForm.getValues().works,
            items: itemsForm.getValues().items,
            payments: paymentsForm.getValues().payments,
            reference: documentForm.getValues().reference,
        }
    }


    function createBreadcrumbData(state: any){

        const thisPageLink = 'id' in documentForm.getValues() ?
            `/documents/${(documentForm as  UseFormReturn<DocumentEdit>).getValues("id")}` :
            `/documents/add?documentType=${settings?.id}`;

        return [
            {
                name: "מסמכים",
                link: "/documents",
            },
            {
                name: "הוספת מסמך",
            },
            {
                name: `${settings?.name}`,
                link: thisPageLink,
                state: state
            }
        ];
    }


    function editCustomDataStructure() {

        const currentState = createState();
        const breadcrumbData = createBreadcrumbData(currentState)

        navigate(`/documents/structure/document?documentType=${settings.id}`, {
            replace: true,
            state: {
                breadcrumbData: [...breadcrumbData, { name: "הגדרת מבנה" }, { name: "מידע נוסף" }]
            }
        });
    }


    return (
        <>
            <div className="title">
                <div>
                    <Typography variant="body1" component="span" sx={{
                        color: !isDocumentClosed ? "text.primary" : "action.disabled",
                    }}>
                        מידע נוסף:
                    </Typography>
                </div>
                <div>
                    <Tooltip title="הגדרת שדות מידע נוסף" placement="top">
                        <span>
                            <IconButton onClick={editCustomDataStructure} sx={{ color: isDocumentClosed ? "rgba(0,0,0,0.3)" : theme.colors.main_color }}>
                                <SettingsIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                </div>
            </div>

            <FieldsRow>
                {structure
                    ?.filter(field => field.type === "מסמך" && !!field.custom_field)
                    .sort((a, b) => (a.location || 0) - (b.location || 0))
                    .map(field => renderCustomDataField(field, documentForm as UseFormReturn<DocumentEdit>))}
            </FieldsRow>
        </>
    )
}

export default DocumentCustomData
